import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const { user } = useAuth();
  const [tenantId, setTenant] = useState(localStorage.getItem("sgi_tenant") || "");
  const [organizations, setOrganizations] = useState([]);

  const setTenantId = (id) => {
    setTenant(id || "");
    if (id) localStorage.setItem("sgi_tenant", id);
    else localStorage.removeItem("sgi_tenant");
  };

  const refreshOrgs = async () => {
    try {
      const r = await api.get("/organizations");
      setOrganizations(r.data);
      return r.data;
    } catch (_) {
      return [];
    }
  };

  useEffect(() => {
    if (user && user.role) {
      refreshOrgs().then((orgs) => {
        if (user.role === "client_user") setTenantId(user.tenant_id);
        else if (tenantId && !orgs.find((o) => o.id === tenantId)) setTenantId("");
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const currentOrg = organizations.find((o) => o.id === tenantId);

  return (
    <TenantContext.Provider
      value={{ tenantId, setTenantId, organizations, refreshOrgs, currentOrg }}
    >
      {children}
    </TenantContext.Provider>
  );
}

export const useTenant = () => useContext(TenantContext);
